module.exports = __webpack_public_path__ + "img/ic_checkbox_inactive.f7aca81.svg";